// src/data/electronic.js

import image1 from "../assets/electronicStamp/electronic1.jpg";

const electronicStampData = [
  {
  id: 1,
  name: "Electronic Stamp PNG",   // key
  category: "electronic",
  image: image1,
  size: "All Sizes",             // key
  description: "ElectronicStampDesc"  // key
  },
];

export default electronicStampData;
